import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import LinkInput from './LinkInput';
import SelectableTags from './SelectableTags';
import ShareButton from './ShareButton';
import { Link } from 'react-router-dom';
import PlatformRatings from './PlatformRatings';
import ArtPage from './ArtPage';
// import ArtThumbnail from './ArtThumbnail';
import { tagName, tagColor } from "./TagsInput"; // Reuse functions from TagsInput
import { saveStateAndScroll, restoreStateAndScroll } from './../utils/stateManager';
import ExpandableImage from './ExpandableImage';
import 'delayed-scroll-restoration-polyfill';
import ArtThumbnail from './ArtThumbnail.js';
import TextUserPair from './TextUserPair.js';
import { formatYear } from './../utils.js'; // Import the global function

const PersonalArtEvents = ({eventType, userId, repeatedEnter = false}) => {
  const navigate = useNavigate();

  const myUser = useContext(MyUserContext);
  const [finishedInput, setFinishedInput] = useState("");
  const [finishedEvents, setFinishedEvents] = useState(null);

  const [hasAccess, setHasAccess] = useState(true);

  const [artNameTerm, setArtNameTerm] = useState('');

  const { pathUserId } = useParams();
  const effectiveUserId = () => {
    // UserID from props or path param.
    let effectiveUserId = userId;
    if (!effectiveUserId) {
      effectiveUserId = pathUserId;
    }
    return effectiveUserId;
  }

  const alreadySelectedTagIds = new URLSearchParams(window.location.search).getAll('tags');

  const alreadySelectedTagIdsParam = alreadySelectedTagIds.map((t) => { return "tags="+t}).join("&");
  const initEventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${alreadySelectedTagIdsParam}`;
  const [nextUrl, setNextUrl] = useState(initEventsFetchUrl);
  const [loading, setLoading] = useState(false);
  const observer = useRef();

  const searchInputRef = useRef(null);
  const [shouldFocus, setShouldFocus] = useState(repeatedEnter);
  const [gridClass, setGridClass] = useState('grid-cols-4');

  const toggleGridCols = () => {
    setGridClass((prevClass) => (prevClass === 'grid-cols-4' ? 'grid-cols-6' : 'grid-cols-4'));
  };

  useEffect(() => {
    // alert("repeatedEnter=" + repeatedEnter);
    // Focus the input when the component mounts or when the user navigates back to this page    
    if (searchInputRef.current) {
      if (shouldFocus) {
        searchInputRef.current.focus();
      } else {
        searchInputRef.current.blur();
      }
    }
  });

  useEffect(() => {
    // Enable scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // TODO: use this to save state and scroll position when navigating away
  // useEffect(() => {
  //   // Restore state and scroll when navigating back
  //   restoreStateAndScroll((restoredState) => {
  //     if (restoredState) {
  //       setFinishedEvents(restoredState.finishedEvents || null);
  //       setArtNameTerm(restoredState.artNameTerm || '');
  //       setNextUrl(restoredState.nextUrl || initEventsFetchUrl);
  //     }
  //   });
  // }, []);

  // const handleNavigation = () => {
  //   // Save state and scroll before navigating away
  //   saveStateAndScroll(window.location.pathname, {
  //     finishedEvents,
  //     artNameTerm,
  //     nextUrl,
  //   });
  //   navigate('/some-other-path'); // Example navigation
  // };

  const [fetching, setFetching] = useState(false);

  const [curUser, setCurUser] = useState(null); // some other user
  const fetchCurUser = () => {
    axiosInstance
    .get(`/users/${effectiveUserId()}`)
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);      
    });
  }

  const [relevantTags, setRelevantTags] = useState(null);
  const fetchRelevantTags = (alreadySetTagIds=[]) => {
    const tagParams = alreadySetTagIds.map((n) => { return "alreadySetTags="+n; }).join("&");
    axiosInstance
    .get(`/relevant/tags?userId=${effectiveUserId()}&type=${eventType}&${tagParams}`)
    .then((response) => {
      setRelevantTags(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const [showTags, setShowTags] = useState(false);

  const [unfinishedRecomsCount, setUnfinishedRecomsCount] = useState(null);
  const fetchUnfinishedRecomsCount = () => {
    axiosInstance
    .get('/recommendations/unfinished/count')
    .then((response) => {
      setUnfinishedRecomsCount(response.data.unfinished);
    })
    .catch((error) => {
      // console.error(error.message);
    })
  }

  const [selectedItem, setSelectedItem] = useState(null);

  const modalRef = useRef(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    const rect = modalRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const modal = modalRef.current;
    const deltaX = e.touches[0].clientX - dragOffset.x;
    const deltaY = e.touches[0].clientY - dragOffset.y;
    if (deltaX < 0) {
      return; // Prevent dragging to the left
    }

    // Enable drag only if deltaX > deltaY
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Disable scrolling.
      modal.style.overflow = 'hidden';
      modal.addEventListener('touchmove', preventDefault, { passive: false });

      modal.style.transform = `translate(${deltaX}px, 0)`;

      // Reduce width and height proportionally, scale more slowly
      const scale = 1 - Math.min(deltaX / (window.innerWidth * 2), 0.1); // Limit reduction to 10%
      modal.style.transform += ` scale(${scale})`;

      // Enable vertical drag after horizontal drag
      if (Math.abs(deltaX) > 70) {
        modal.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scale})`;
      }
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    // Enable scrolling again.
    modalRef.current.style.overflow = 'auto';
    modalRef.current.removeEventListener('touchmove', preventDefault);

    const rect = modalRef.current.getBoundingClientRect();
    const modalWidth = rect.width;

    // Close modal if dragged to the right by at least 20% of its width
    if (rect.left - dragOffset.x > modalWidth / 5) {
      setSelectedItem(null);
    } else {
      // Reset position if not dragged far enough
      modalRef.current.style.transform = "translate(0, 0)";
    }
  };

  const fetchFinishedEvents = (nextUrl, fromScratch = false) => {
    if (!nextUrl || loading) {
      return;
    }
    setLoading(true);
    axiosInstance
    .get(nextUrl)
    .then((response) => {
      if (finishedEvents === null || fromScratch) {
        setFinishedEvents(response.data.data);
      } else {
        setFinishedEvents(prevObjects => [...prevObjects, ...response.data.data]);
      }
      setNextUrl(response.data.nextPageUrl);
    })
    .catch((error) => {
      if (error.response) {
        // Server responded with a status other than 200 range
        if (error.response.status === 403 || error.response.status === 401) {
          // Handle 403 Forbidden
          setHasAccess(false);
          console.log("Setting has access to false");
        } else {
          console.error('Error: ', error.response.data);
        }
      } else {
        console.error(error);  
      }
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const handleFinishedInputChange = (event) => {
    setFinishedInput(event.target.value);
  };
  const handleFinished = () => {
    axiosInstance
    .post(`/artEvents`, { wikiArticleLink: finishedInput, type: eventType })
    .then((response) => {
      if (finishedEvents === null) {
        setFinishedEvents(response.data);
      } else {
        setFinishedEvents(prevObjects => [response.data, ...prevObjects]);  
      }
      setFinishedInput("");
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const lastObjectRef = useCallback(node => {
    if (loading) return;

    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        fetchFinishedEvents(nextUrl);
      }
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [loading, nextUrl, fetchFinishedEvents]);

  const curUserIsMe = () => {
    return (myUser && effectiveUserId() === myUser.myUserInfo.myUserId);
  }

  const isMobileDeviceExceptAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iphone|ipad|ipod|windows phone|blackberry/i.test(userAgent);
  };

  const isFirefox = () => {
    return navigator.userAgent.toLowerCase().includes('firefox');
  };

  const isMobile = () => window.innerWidth <= 768;

  const handleItemClick = (item) => {
    if (isMobile()) {
      setSelectedItem(item); // Open modal on mobile
    } else {
      navigate(`/arts/${item.art.id}`); // Navigate on desktop
    }
  };

  const handleRecalcClick = (smart) => {
    const urlParts = window.location.pathname.split('/');
    const userId = urlParts[2]; // Extract the user ID from the URL

    axiosInstance.post(`/user/${userId}/recalc${smart ? '?smart=true' : ''}`)
      .then(response => {
        alert('Recalculation started successfully');
      })
      .catch(error => {
        alert('Could not start recalculation');
      });
  };
  const handleUserMatchRecalcClick = () => {
    axiosInstance.post(`/userMatch/recalc`)
      .then(response => {
        alert('User match recalculation started successfully');
      })
      .catch(error => {
        alert('Could not start user match recalculation');
      });
  };
  const handleHotRecalcClick = () => {
    axiosInstance.post(`/recalc/hot`)
      .then(response => {
        alert('Hot recalculation started successfully');
      })
      .catch(error => {
        alert('Could not start hot recalculation');
      });
  };

  if (hasAccess && (finishedEvents === null || (curUser === null))) {
    if (fetching === false) {
      setFetching(true);
      fetchFinishedEvents(nextUrl);
      fetchUnfinishedRecomsCount();
      //if (!curUserIsMe()) {
        fetchCurUser();
      //}

      // const searchParams = new URLSearchParams(window.location.search);
      // const alreadySelectedTagNames = searchParams.getAll('tags');
      fetchRelevantTags(alreadySelectedTagIds);
    }
    return (
      <div></div>
    )
  } else {
    // setFetching(false); // Needed to comment to avoid re-render, wtf
  }

  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  let buttonTextLocalizeKey = "addFinished";
  if (eventType === "like") {
    buttonTextLocalizeKey = "like";
  } else if (eventType === "todo") {
    buttonTextLocalizeKey = "addTodo";
  }

  // console.log("finishedEvents[0].event.chatId: " + finishedEvents[0].event.chatId);

  // Links to other types of events: start
  // TODO: move it to a separate user page component.
  const likesLink = `/users/${effectiveUserId()}/likes`;
  const classLikes = (eventType === "like" ? "underline" : "");

  const todosLink = `/users/${effectiveUserId()}/todos`;
  const classTodos = (eventType === "todo" ? "underline" : "");

  const finishedLink = `/users/${effectiveUserId()}/finished`;
  const classFinished = (eventType === "finished" ? "underline" : "");

  // Links to other types of events: end

  return (
    <div class="container mx-auto px-1 md:px-2 w-full lg:w-1/2">
      {/* <div class="container mx-auto">
        {
          myUser && effectiveUserId() !== myUser.myUserInfo.myUserId &&
            <TextUserPair user={curUser} userId={effectiveUserId()} hideRecomInput={true}/>
        }        
      </div> */}
      {
      (hasAccess === false) ?
        <div class="flex justify-center text-center">
          {language === "ru" ? "Приватный аккаунт, подпишитесь на пользователя и дождитесь подтверждения" : "Account is private, subscribe to user and wait for approval"}
        </div> 
        :
          <>
            {myUser?.myUserInfo?.myUserId === '4312f009-7502-43a6-9483-2824508fe96f' && (
              <>
                <button onClick={()=>{handleRecalcClick(false);}} style={{ margin: '10px', padding: '10px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '5px' }}>
                  Recalculate
                </button>
                <button onClick={()=>{handleRecalcClick(true);}} style={{ margin: '10px', padding: '10px', backgroundColor: 'green', color: 'white', border: 'none', borderRadius: '5px' }}>
                  Recalculate smart
                </button>
                <button onClick={()=>{handleHotRecalcClick();}} style={{ margin: '10px', padding: '10px', backgroundColor: 'gray', color: 'white', border: 'none', borderRadius: '5px' }}>
                  Recalculate hots
                </button>
                <button onClick={()=>{handleUserMatchRecalcClick();}} style={{ margin: '10px', padding: '10px', backgroundColor: 'red', color: 'white', border: 'none', borderRadius: '5px' }}>
                  Recalculate user match
                </button>
              </>
            )}

            {
            (eventType === 'like') &&
            <div>
              {/*<div className="flex justify-between items-center mt-2 mb-1 px-2">
                <div class="flex justify-center items-center space-x-2">
                  <Link to={"/logbookHistory?userId="+effectiveUserId()}>
                      <div class="container mx-auto flex justify-center items-center">
                      <div class="flex group-hover:hidden">
                        <img class="mt-0.5 max-w-9 max-h-9" src="/calendar_icon_2.png" alt="Calendar" />
                      </div>
                    </div>
                  </Link>
                  {
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId) &&
                    <Link to="/settings">
                      <img
                        src="/settings_icon.png"
                        alt={language === "ru" ? "Настройки" : "Settings"}
                        className="w-9 h-9 cursor-pointer"
                        // onClick={() => navigate('/settings')} // Example navigation to settings
                      />
                    </Link>
                  }
                </div>
              </div> */}
              <div>
                <div class="flex justify-between items-center space-x-1 px-2 mt-1">

                  <div class="flex items-center space-x-1">
                    <TextUserPair user={curUser} hideRecomInput={true} />  
                    <span className="text-lg font-bold">
                    ·
                    </span>
                    <Link to={`/users?onlyMyFollowers=true&forUserId=${effectiveUserId()}`}>
                      {language === "ru" ? "Подписчики" : "Followers"}
                    </Link>
                    <span className="text-lg font-bold">
                    ·
                    </span>
                    <Link to={`/users?onlyMyFollowees=true&forUserId=${effectiveUserId()}`}>
                      {language === "ru" ? "Подписки" : "Followings"}
                    </Link>
                  </div>

                  <div class="flex items-center space-x-1">
                    <Link to={"/logbookHistory?userId="+effectiveUserId()}>
                        <div class="container mx-auto flex justify-center items-center">
                        <div class="flex group-hover:hidden">
                          <img class="mt-0.5 max-w-9 max-h-9" src="/calendar_icon_2.png" alt="Calendar" />
                        </div>
                      </div>
                    </Link>
                    {
                    (myUser && effectiveUserId() === myUser.myUserInfo.myUserId) &&
                      <Link to="/settings">
                        <img
                          src="/settings_icon.png"
                          alt={language === "ru" ? "Настройки" : "Settings"}
                          className="w-9 h-9 cursor-pointer"
                          // onClick={() => navigate('/settings')} // Example navigation to settings
                        />
                      </Link>
                    }
                  </div>

                </div>

                <span className="flex text-lg font-bold text-center">
                  {
                  (curUser.id !== myUser.myUserInfo.myUserId && curUser.matchScore) &&
                    <div className="ml-2 text-sm text-gray-400 leading-none">
                      <div>
                        &nbsp;
                        {Math.floor(curUser.matchScore*100) + "%" + " "}
                        {language === "ru" ? "совпадение вкусов" : "match of tastes"}
                      </div>
                      <div>
                        &nbsp;
                        {language === "ru" ? `(на основе ${curUser.matchArtsCount} произведений)` : "(based on ${curUser.matchArtsCount} arts)"}
                      </div>
                    </div>
                  }
                </span>
              </div>
            </div>
            }

            {
            (finishedEvents && finishedEvents.length == 0) && artNameTerm === '' && !loading &&
              <div class="mt-5 justify-center text-center">
                {
                language === "ru"
                ?                  
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?
                    eventType.includes('recommendation')
                    ?
                      <>
                        
                      </>
                    :
                      <>
                        Вы пока не добавили ни одного произведения в свою библиотеку.
                        Перейдите в поиск <img class="inline max-w-6 max-h-6" src="/add_icon.png" /> и добавьте произведения.
                      </>
                  :
                    <>
                      Пользователь пока не добавил ни одного произведения в свою библиотеку.
                    </>
                :
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?                    
                    eventType.includes('recommendation')
                    ?
                      <>
                        No personal recommendations yet.
                      </>
                    :
                      <>
                        You have not added any arts yet to your library.
                        Go to search <img class="inline max-w-6 max-h-6" src="/add_icon.png" /> and add arts.
                      </>                    
                  :
                    <>
                      The user has not added any arts yet to their library.
                    </>
                }
              </div>
            }

            {
            (finishedEvents && finishedEvents.length > 0 || artNameTerm.length > 0 || eventType.includes('recommendation')) &&
            <div class={"rounded-md border-gray-300 border-dotted left-0 w-full z-50 justify-center" + (myUser ? " bottom-20" : " bottom-0")}>

              <div class="flex justify-center items-center space-x-4">
                {
                myUser && effectiveUserId() === myUser.myUserInfo.myUserId &&
                  (
                    eventType.includes('recommendation')
                    &&
                      <div>
                        <span class="font-bold">
                          {language === "ru" ? "Рекомендации между друзьями" : "Recommendations between friends"}
                        </span>
                        <div class="flex justify-center items-center text-center space-x-4">
                          <Link to={`/users/${effectiveUserId()}/recommendationsIncoming`}>
                            <span class={"text-gray-300 hover:text-gray-700" + (eventType === "recommendationIncoming" ? " underline" : "")}>
                              {language === "ru" ? "Мне" : "To me"} 
                            </span>
                          </Link>
                          <Link to={`/users/${effectiveUserId()}/recommendationsOutgoing`}> 
                            <span class={"text-gray-300 hover:text-gray-700" + (eventType === "recommendationOutgoing" ? " underline" : "")}>
                              {language === "ru" ? "От меня" : "From me"} 
                            </span>
                          </Link>  
                        </div>
                      </div>
                  )                
                }
              </div>

              <div class="flex justify-center items-center mt-6 mb-0.5">
                <div class="flex my-1 px-4 py-2 rounded-xl bg-[#3A3B3C] font-[sans-serif]">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904" width="16px"
                    class="fill-gray-600 mr-3 rotate-120">
                    <path
                      d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z">
                    </path>
                  </svg>
                  <input ref={searchInputRef} type="search" class="w-64 bg-[#3A3B3C] outline-none text-gray-300 text-lg"
                    onChange={
                      (e) => {
                        const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=${e.target.value}`;
                        fetchFinishedEvents(eventsFetchUrl, true);

                        setArtNameTerm(e.target.value); // to intercept in tags selection
                        setShouldFocus(true);
                      }
                    }
                    placeholder={language === "ru" ? ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Поиск в библиотеке пользователя" : "Поиск в моей библиотеке") : ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Search in user's library" : "Search in my library")}
                  />
                  {
                  (isMobileDeviceExceptAndroid() || isFirefox()) && artNameTerm &&
                    <span class="hover:cursor-pointer text-lg" onClick={()=>{
                        const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=`;
                        fetchFinishedEvents(eventsFetchUrl, true);

                        setArtNameTerm(''); // is it really neede if there's update via ref?
                        searchInputRef.current.value = '';
                        searchInputRef.current.focus();
                      }
                    }>
                      &times;
                    </span>
                  }
                </div>
                {/* {
                (finishedEvents && finishedEvents.length > 5) &&
                  <div class="ml-2 text-4xl leading-none transform translate-y-[-2px] hover:cursor-pointer hover:text-gray-400" onClick={toggleGridCols}>
                    ⊞
                  </div>
                } */}
                {/*
                <div class="text-3xl">
                  {
                    eventType === "like" &&
                    <ShareButton
                      url={
                        window.location.href
                      }
                      text={
                        ""
                      }
                      overrideButtonText="🔗"
                    />
                  }
                </div>
                */}
              </div>
              {
              // showTags &&
              <div class="mb-1">
                <SelectableTags language={language} relevantTags={relevantTags !== null ? relevantTags : []} alreadySelectedTags={ relevantTags ? relevantTags.filter((t) => alreadySelectedTagIds.includes(t.tag.id)) : []} onSelectionChange={(tags) => {
                  const tagParams = tags.map((t) => { return "tags="+t.tag.id; }).join("&");

                  const url = 'https://wowcontent.lol';
                  // const url = 'http://localhost:8080'
                  let urlEventType = "likes";
                  if (eventType === "recommendationIncoming") {
                    urlEventType = "recommendationsIncoming";
                  } else if (eventType === "recommendationOutgoing") {
                    urlEventType = "recommendationsOutgoing";
                  }
                  window.history.pushState({}, '', `${url}/users/${curUser.id}/${urlEventType}${ tagParams ? "?"+tagParams : "" }`);

                  const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${tagParams}&artNameTerm=${artNameTerm}`;
                  fetchFinishedEvents(eventsFetchUrl, true);

                  const tagIds = tags.map((t) => { return t.tag.id; });
                  fetchRelevantTags(tagIds);
                }} />
              </div>
              }
            </div>
            }
            {/* Grid */}
            <div className={`grid ${gridClass} gap-3 mt-1`}>
              {finishedEvents.map((item, index) => (
                <div
                  class="mb-2"
                  key={index}
                  ref={index === finishedEvents.length - 1 ? lastObjectRef : null} // Restore lastObjectRef
                >
                  <Link to={"/arts/"+item.art.id} >
                    <ArtThumbnail art={item.art} displayCheckmark={eventType !== "like"} displayTag={false/*eventType === "like"*/}/>
                  </Link>
                  {
                  gridClass === 'grid-cols-4' ?
                  <>
                      <div class="text-center w-full font-medium text-sm tracking-wide leading-snug text-white">
                        {( (language === "en" || !item.art.ruName) ? item.art.name : item.art.ruName) + formatYear(item.art.year, language)}
                      </div>
                      <div className="flex justify-center text-center items-center mt-[8px]">
                        <PlatformRatings art={item.art} />
                      </div>
                      { <div class="flex justify-center mt-[7.5px]">
                      {
                        eventType.includes('like') && (
                          <div
                            className={`opacity-75 text-center overflow-hidden whitespace-nowrap truncate ${tagColor(item.event.eventTags.find(t => t.type === 3).name, true, undefined, 0)}`}
                          >
                            {tagName(item.event.eventTags.find(t => t.type === 3).name, language)}
                          </div>
                        )
                      }
                      </div> }
                      {
                        eventType.includes('recommendation') ?
                          <>
                            <Link to={`/artEvents/${item.event.id}`}>
                              <div className="flex justify-center items-center mt-0.5">
                                {item.event.eventTags?.slice(0, 5).map((tag, idx) => (
                                  <img
                                    key={idx}
                                    src={tag.imgUrl}
                                    alt={tag.name}
                                    className="w-8 h-8 rounded-full object-cover border border-white"
                                  />
                                ))}
                                <span className="ml-2 text-gray-500 text-lg">&#8250;</span> {/* Unicode chevron */}
                              </div>
                            </Link>
                          </>
                        :
                          <div className="flex justify-center opacity-70 hover:opacity-100 mt-[1px]">
                            <Link to={`/artEvents/${item.event.id}`}>
                              <img
                                src="/chat_icon.png"
                                alt={language === "ru" ? "К моему обсуждению" : "Go to my discussion"}
                                className="inline-block w-6 h-6" // Increased size by 1.5x
                              />
                              {item.chat?.messageCount > 0 && (
                                <span className="ml-1 text-white text-sm">
                                  {item.chat.messageCount}
                                </span>
                              )}
                            </Link>
                          </div>
                      }
                  </>
                  :
                  <>
                    {
                      eventType.includes('like') && (
                        <div class="flex justify-center mt-0.5">
                        <div
                            className={`text-center overflow-hidden whitespace-nowrap truncate ${tagColor(item.event.eventTags.find(t => t.type === 3).name, true, undefined, 0)}`}
                          >
                            {tagName(item.event.eventTags.find(t => t.type === 3).name, language)}
                          </div>
                        </div>
                      )
                    }
                  </>
                  }
                  
                </div>
              ))}
            </div>
            {/* <button onClick={handleNavigation}>Navigate</button> */}
            
          </>
      }
      
    </div>
  );
}

export default PersonalArtEvents;